import React from "react";
import { Flex, List, Skeleton } from "antd";

import { BusinessServicesListItemSkeleton } from "../BusinessServicesListItem";
import { BusinessCardSkeleton } from "../BusinessCard";

const BusinessListItemSkeleton: React.FC = () => {
  return (
    <Flex gap={32} flex={1}>
      <BusinessCardSkeleton />
      <Flex flex={1} vertical>
        <Skeleton paragraph={{ rows: 1 }} />

        <List
          itemLayout="horizontal"
          size="large"
          dataSource={[1, 2, 3]}
          renderItem={(_, index) => <BusinessServicesListItemSkeleton key={index} />}
        />
      </Flex>
    </Flex>
  );
};

export default BusinessListItemSkeleton;
